import { useLocation, useRouteMatch } from 'react-router-dom';
import { useShouldSelectBranch } from './useShouldSelectBranch';

export function useLayoutVisibility() {
  const isSelectingLoginBranch = useShouldSelectBranch();

  const location = useLocation();
  const isHomePage = location.pathname.includes('/home');
  const isRewardPage = location.pathname.includes('/reward');
  const isShoppingPage = location.pathname.includes('/shopping');
  const isShopRewardPage = location.pathname.includes('/shop-reward');
  const isCheckoutPage = location.pathname.includes('/checkout');
  const isAddressPage = location.pathname.includes('/address');
  const isPaymentPage = location.pathname.includes('/payment');
  const isSlipPage = location.pathname.includes('/up-slip');
  const isOrderPage = location.pathname.includes('/order');
  const isPromotionPage = location.pathname.includes('/promotion/');
  const isShopProductPage = location.pathname.includes('/shopProduct/');
  const isShopProductPage2 =
    location.pathname.includes('/products/') &&
    (location.pathname.includes('/new') || location.pathname.includes('/edit'));
  //   const isOrderHistoryPage = location.pathname.includes('/order-history');
  //   const isorderManagementPage = location.pathname.includes('/orderManagement');
  const isInventoryPage = location.pathname.includes('inventory');
  const isShoppingCartSettingPage = location.pathname.includes('/shopping-cart-setting');
  const isLineOASettingPage = location.pathname.includes('/setting-line-oa');
  const isContactPage =
    location.pathname.includes('/board') ||
    location.pathname.includes('customer-contact') ||
    location.pathname.includes('contact');
  const isRegistrationSettingPage = location.pathname.includes('registration-perks');
  const isBranchManagePage = location.pathname.includes('branch-management');
  const isAddOnPage = location.pathname.includes('add-on');
  const isSelectPaymentPage = location.pathname.includes('select-payment') && location.pathname.includes('order');
  const isSelectCategoryPage = location.pathname.includes('categories');
  const isDashboardPage = location.pathname.includes('statistics');
  const isCustomersPage = useRouteMatch('/shop/:shopId/admin/customers')?.isExact;
  const isAdminPage = location.pathname.includes('admin');
  const isInvitePage = location.pathname.includes('invite');
  const isBookingPage = location.pathname.includes('booking');

  const isBooking2RegisSettingPage = useRouteMatch('/shop/:shopId/booking2/:branchId/registration-setting')?.isExact;
  const isBooking2ServiceSettingPage = useRouteMatch('/shop/:shopId/booking2/:branchId/service')?.isExact;
  const isBooking2WorkingdaySettingPage = useRouteMatch('/shop/:shopId/booking2/:branchId/holiday')?.isExact;
  const isBooking2HolidaySettingPage = useRouteMatch('/shop/:shopId/booking2/:branchId/workingday')?.isExact;
  const isBooking2ConditionSettingPage = useRouteMatch('/shop/:shopId/booking2/:branchId/condition')?.isExact;
  const isBooking2EditServicePage = useRouteMatch('/shop/:shopId/booking2/:branchId/service/:serviceId/edit')?.isExact;
  const isBooking2ReviewPage = useRouteMatch('/shop/:shopId/booking2/:branchId/review')?.isExact;
  const isBooking2NotiPage = useRouteMatch('/shop/:shopId/booking2/:branchId/notification')?.isExact;
  const isBooking2CreateServicePage = useRouteMatch('/shop/:shopId/booking2-createbooking/:branchId/create-service')
    ?.isExact;
  const isBooking2CreateCustomerDataPage = useRouteMatch(
    '/shop/:shopId/booking2-createbooking/:branchId/create-customerdata'
  )?.isExact;
  const isBooking2CheckoutPage = useRouteMatch('/shop/:shopId/booking2-createbooking/:branchId/transaction')?.isExact;
  const isBooking2UploadSlipPage = useRouteMatch('/shop/:shopId/booking2-createbooking/upload-slip/:bookingId');
  const isBooking2ConfirmPage = useRouteMatch('/shop/:shopId/booking2-createbooking/:branchId/confirm')?.isExact;
  const isBooking2ConditionPage = useRouteMatch('/shop/:shopId/booking2-createbooking/:branchId/condition')?.isExact;
  const isBookingManageMent = useRouteMatch('/shop/:shopId/booking2/:branchId/management');
  const isBookingHistory = useRouteMatch('/shop/:shopId/booking2-history');
  const isRedeemHistoryPage = useRouteMatch('/shop/:shopId/redeem-history');

  const isShopAiSettingPage = useRouteMatch('/shop/:shopId/admin/ai-setting')?.isExact;
  const isUploadFilePage = useRouteMatch('/shop/:shopId/admin/upload-file')?.isExact;
  const isCreateFunsharingPage = useRouteMatch('/shop/:shopId/admin/funsharing/create')?.isExact;
  const isEditFunsharingPage = useRouteMatch('/shop/:shopId/admin/funsharing/edit/:funsharingId')?.isExact;

  const hideLayout =
    isHomePage ||
    isRewardPage ||
    isShoppingPage ||
    isShopRewardPage ||
    isCheckoutPage ||
    isAddressPage ||
    isPaymentPage ||
    isSlipPage ||
    isOrderPage ||
    isPromotionPage ||
    isShopProductPage ||
    isShopProductPage2 ||
    isInventoryPage ||
    isShoppingCartSettingPage ||
    isContactPage ||
    isLineOASettingPage ||
    isRegistrationSettingPage ||
    isBranchManagePage ||
    isContactPage ||
    isSelectingLoginBranch ||
    isAddOnPage ||
    isSelectPaymentPage ||
    isSelectCategoryPage ||
    isDashboardPage ||
    isCustomersPage ||
    isBooking2RegisSettingPage ||
    isBooking2ServiceSettingPage ||
    isBooking2WorkingdaySettingPage ||
    isBooking2HolidaySettingPage ||
    isBooking2ConditionSettingPage ||
    isBooking2EditServicePage ||
    isBooking2ReviewPage ||
    isBooking2CreateServicePage ||
    isBooking2CreateCustomerDataPage ||
    isBooking2CheckoutPage ||
    isBooking2UploadSlipPage ||
    isBooking2ConfirmPage ||
    isBooking2ConditionPage ||
    isBooking2NotiPage ||
    isBookingManageMent ||
    isBookingHistory ||
    isShopAiSettingPage ||
    isAdminPage ||
    isInvitePage ||
    isBookingPage ||
    isRedeemHistoryPage ||
    isUploadFilePage ||
    isCreateFunsharingPage ||
    isEditFunsharingPage;

  return {
    hideLayout
  };
}
